import ObjectID from "bson-objectid";


export default class Location {

  constructor(data) {
    this.id = Location.MakeId();
    this.mapboxId = null;
    this.parent = null;
    this.title = null;
    this.type = null;
    
    this.address = null;
    this.address2 = null;
    this.place = null;
    this.postCode = null;
    this.country = null;
    this.region = null;

    this.coordinates = null;
    this.replaceFn = (data) => this.replace(data);
    this.removeFn = () => this.remove();
    this.setData(data);
  }

  get shortTitle() {
    return this.title.length < 20 ? this.title : this.title.substring(0, 18) + "..";
  }

  get hasCoordinates() {
    return !!this.coordinates && this.coordinates?.length >= 2;
  }

  get isEmpty() {
    return this.id === null || (this.coordinates === null && !this.address);
  }

  setData({ id = null, mapboxId = null, address = "", title = "", type = "address", coordinates = null, place = null, country = null, region = null, postCode = null, address2 = null } = {}, broadcast = true) {
    this.id = id || this.id;
    this.mapboxId = mapboxId;
    this.address = address;
    this.address2 = address2;
    this.title = title;
    this.type = type;
    this.coordinates = coordinates;
    this.place = place;
    this.country = country;
    this.postCode = postCode;
    this.region = region;
    if (broadcast) {
      this.parent?.broadcast();
    }
  }

  getData() {
    return {
      id: this.id,
      mapboxId: this.mapboxId,
      address: this.address,
      address2: this.address2,
      title: this.title,
      type: this.type,
      place: this.place,
      country: this.country,
      postCode: this.postCode,
      region: this.region,
      coordinates: this.coordinates
    }
  }

  remove() {
    this.parent?.remove(this);
  }

  replace(newLocation) {
    if (!!newLocation) {
      this.parent?.replace(this, newLocation);
    }
  }

  static MakeId() {
    const oid = new ObjectID();
    return oid.toHexString();
  }

  static ShortAddress(title = undefined, address = undefined) {
    if (!title && !address) {
      return "-";
    } else if (!!title && (title !== address || !address)) {
      return title;
    }

    const item = title || address;
    const idx = item.indexOf(",");
    return idx === -1 ? item : item.substring(0, idx);
  }

  getGeoJson(properties = {}) {
    return {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": this.coordinates
      },
      "properties": {
        "title": this.shortTitle?.replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, ''),
        ...properties
      }
    };
  }

}